ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/ace-builds/src-min-noconflict/snippets/json.js
// module id = 1752
// module chunks = 3